import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-info-card',
  standalone: false,
  templateUrl: './info-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './info-card.component.scss',
})
export class InfoCardComponent {

    @Input()
    title = "";

    @Input()
    text = "";

    @Input()
    icon = "";
}
